export async function getVenues() {
  const res = await fetch(
    'https://statics.pinchos.se/api/venues/en/all.slim.4.json',
  );
  const data = await res.json();
  return data;
}
